import { useState } from 'react';

import { useMakeAPaymentCommitments } from '@sola/supporter-sdk/hooks/commitments.js';

import {
  MakeAPaymentAlert,
  MakeAPaymentAlertType,
} from '../../molecules/make-a-payment-alert/make-a-payment-alert';
import { MakeAPaymentSheet } from './make-a-payment-sheet';

export interface MakeAPaymentNoticeProps {
  onlyShowMissingPayment?: boolean;
}

export const MakeAPaymentNotice: React.FC<MakeAPaymentNoticeProps> = ({
  onlyShowMissingPayment = false,
}) => {
  const [isOpen, setIsOpen] = useState(false);

  const {
    amountDue,
    hasMissedPayment,
    hasDueThisMonth,
    canPayAhead,
    alertCommitments,
  } = useMakeAPaymentCommitments();

  if (
    (!hasMissedPayment && onlyShowMissingPayment) ||
    (!hasMissedPayment && !hasDueThisMonth && !canPayAhead)
  ) {
    return;
  }

  const makeAPaymentAlert = {
    amountDue,
    commitments: alertCommitments,
    alertType: MakeAPaymentAlertType.payAhead,
    ...(hasMissedPayment && {
      alertType: MakeAPaymentAlertType.missingPayment,
    }),
    ...(hasDueThisMonth &&
      !hasMissedPayment && {
        alertType: MakeAPaymentAlertType.paymentDue,
      }),
  };

  return (
    <>
      <MakeAPaymentAlert
        {...makeAPaymentAlert}
        onButtonClick={() => setIsOpen(true)}
      />
      <MakeAPaymentSheet open={isOpen} onOpenChange={setIsOpen} />
    </>
  );
};
